<template>
  <div class="resignation">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Salary Elements</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Salary</li>
                </ul>
              </div>
              <div class="col-md-3 float-right ml-auto">
                <div class="row">
                  <a @click="openDialog" class="btn btn-primary m-1"
                    ><i class="fa fa-plus"></i> Add Element</a
                  >
                  <a @click="openDialogImport" class="btn btn-primary m-1"
                    ><i class="fa fa-plus"></i> Import Element</a
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="sortedElements"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" @click="setEdit(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" @click="setDelete(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.frequency`]="{ item }">
                    {{ item.frequency == 1 ? "Monthly" : "Variable" }}
                  </template>
                  <template v-slot:[`item.showInPayslip`]="{ item }">
                    {{ item.showInPayslip ? "Yes" : "No" }}
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Salary Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Salary Element</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Name <span class="text-danger">*</span></label>
                  <input
                    v-model.trim="$v.description.$model"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="form-group">
                  <label>Category <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model.trim="$v.categoryId.$model"
                    @change="getSubCategories(true)"
                  >
                    <option>Select Option</option>
                    <option
                      v-for="item in categories"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Sub Category <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model.trim="$v.subCategoryId.$model"
                  >
                    <option>Select Option</option>
                    <option
                      v-for="item in subCategories"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Frequency <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model.trim="$v.frequency.$model"
                  >
                    <option>Select Frequency</option>
                    <option :value="1">Monthly</option>
                    <option :value="2">Variable</option>
                  </select>
                </div>
                <div class="form-group">
                  <label
                    >Show in Payslip <span class="text-danger">*</span></label
                  >
                  <select
                    class="form-control"
                    v-model.trim="$v.showInPayslip.$model"
                  >
                    <option>Select Action</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>GL Account <span class="text-danger">*</span></label>
                  <input
                    v-model.trim="$v.glAccount.$model"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    class="btn btn-primary submit-btn"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Salary Modal -->

        <!-- Edit Salary Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Salary Element</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="updateSalaryElement">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Name <span class="text-danger">*</span></label>
                  <input
                    v-model="element.description"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="form-group">
                  <label>Category <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="element.categoryId"
                    @change="getSubCategories(false)"
                  >
                    <option>Select Option</option>
                    <option
                      v-for="item in categories"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Sub Category <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="element.subCategoryId">
                    <option>Select Option</option>
                    <option
                      v-for="item in subCategories"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Frequency <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="element.frequency">
                    <option>Select Frequency</option>
                    <option :value="1">Monthly</option>
                    <option :value="2">Variable</option>
                  </select>
                </div>
                <div class="form-group">
                  <label
                    >Show in Payslip <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="element.showInPayslip">
                    <option>Select Action</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
                >
                <div class="form-group">
                  <label>GL Account <span class="text-danger">*</span></label>
                  <input
                    v-model="element.glAccount"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="updateSalaryElement"
                    class="btn btn-primary submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Salary Modal -->

        <!-- Delete Salary Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDelete">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Delete Salary Element</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="removeSalaryElement"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      @click="closeDelete"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Resignation Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Salary Element</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Salary Element</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                    Regards <strong>Category</strong> and
                    <strong>Sub Category</strong> columns you are expected to
                    get the value from their representing sheet. <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importElement"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import { paymentService } from "@/services/paymentService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      salarypaymentdialog: false,
      pensionpaymentdialog: false,
      taxpaymentdialog: false,
      methodStatus: 0,
      password: "",
      salaryPayDay: null,
      today: new Date().getDate(),
      headers: [
        {
          text: "Name",
          align: "start",
          value: "description"
        },
        { text: "Category", value: "salaryCategory.name" },
        { text: "Sub Category", value: "salarySubCategory.name" },
        { text: "Frequency", value: "frequency" },
        { text: "Show In Payslip", value: "showInPayslip" },
        { text: "GL Account", value: "glAccount" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      description: "",
      categoryId: null,
      subCategoryId: null,
      frequency: "",
      showInPayslip: null,
      glAccount: "",
      elements: [],
      element: {},
      categories: [],
      loading: false,
      error: "",
      subCategories: [],
      submitted: false,
      file: null,
      fileName: "",
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue,
      message: null
    };
  },

  validations: {
    description: { required },
    categoryId: { required },
    subCategoryId: { required },
    frequency: { required },
    showInPayslip: { required },
    glAccount: { required },
    // resignationDate: { required },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogImport(val) {
      val || this.closeImport();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },
  computed: {
    sortedElements: function() {
      function compare(a, b) {
        if (a.description.toLowerCase() < b.description.toLowerCase())
          return -1;
        if (a.description.toLowerCase() > b.description.toLowerCase()) return 1;
        return 0;
      }

      return this.elements ? this.elements.sort(compare) : this.elements;
    }
  },
  methods: {
    clearModel() {
      this.description = "";
      this.categoryId = null;
      this.subCategoryId = null;
      this.frequency = "";
      this.showInPayslip = null;
      this.submitted = false;
    },

    getCategories() {
      const companyId = this.company.id;
      paymentService.getSalaryCategories(companyId).then(
        model => {
          this.categories = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getElements() {
      const companyId = this.company.id;
      paymentService.getSalaryElements(companyId).then(
        model => {
          this.elements = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getSubCategories(b) {
      const id = b ? this.categoryId : this.element.categoryId;
      const companyId = this.company.id;
      paymentService.getSalarySubCategories(companyId).then(
        model => {
          this.subCategories = model.filter(c => c.categoryId == id);
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    openDialog() {
      this.dialog = true;
    },
    openDialogImport() {
      this.dialogImport = true;
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    closeImport() {
      this.dialogImport = false;
    },
    setEdit(m) {
      this.element = m;
      this.dialogEdit = true;
      this.getSubCategories(false);
    },
    setDelete(model) {
      this.element = model;
      this.dialogDelete = true;
    },

    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.submitted = true;

      this.loading = true;
      var req = {
        companyId: this.company.id,
        description: this.description,
        categoryId: this.categoryId,
        subCategoryId: this.subCategoryId,
        frequency: this.frequency,
        showInPayslip: this.showInPayslip,
        glAccount: this.glAccount
      };

      paymentService.addSalaryElement(req).then(
        id => {
          const companyId = this.company.id;
          paymentService.getSalaryElements(companyId).then(w => {
            (this.elements = w),
              // console.log(w);
              this.close();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    downloadTemplate() {
      paymentService.downloadElementTemplate(this.company.id).then(response => {
        let blob = new Blob([response.data], { type: response.data.type });
        // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.fileName);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // Create a download link
          downloadElement.href = href;
          downloadElement.download = response.fileName; // Download the file name
          document.body.appendChild(downloadElement);
          downloadElement.click(); // click to download
          document.body.removeChild(downloadElement); // Download complete removal element
          window.URL.revokeObjectURL(href); // Release Blob object
        }
      });
    },
    importElement() {
      paymentService.importElement(this.company.id, this.file).then(
        response => {
          const companyId = this.company.id;
          paymentService.getSalaryElements(companyId).then(o => {
            (this.elements = o),
              // console.log(o),
              this.closeImport();
          });
        },
        error => {
          this.error = error;
        }
      );
    },

    updateSalaryElement() {
      this.submitted = true;

      this.loading = true;
      //console.log(this.resignation);
      paymentService.updateSalaryElement(this.element).then(
        id => {
          const companyId = this.company.id;
          paymentService.getSalaryElements(companyId).then(o => {
            (this.elements = o),
              // console.log(o),
              this.closeEdit();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    removeSalaryElement() {
      const id = this.element.id;
      //console.log(this.resignation);
      paymentService.removeSalaryElement(id).then(id => {
        const companyId = this.company.id;
        paymentService.getSalaryElements(this.company.id).then(
          model => {
            this.elements = model;
            // console.log(model);
            this.closeDelete();
          },
          error => {
            error = error;
          }
        );
      });
    }
  },

  mounted() {
    this.getCategories();
    this.getElements();
    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeeResignations(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "salary"
};
</script>



// WEBPACK FOOTER //
// src/components/payroll/salaryElement.vue